import Authorize from './Authorize';
import ChangeEmail from './ChangeEmail/ChangeEmail';
import ChangePassword from './ChangePassword';
import CompleteForgotPassword from '../components/CompleteForgotPassword';
import CompleteSetupMFA from '../components/CompleteSetupMFA';
import ConfirmForgotPassword from './ConfirmForgotPassword';
import ConfirmSignIn from './ConfirmSignIn';
import Error from './Error';
import ForgotPassword from './ForgotPassword';
import IdpToken from './IdpToken';
import ResetPassword from './ResetPassword';
import SetupMFA from './SetupMFA';
import SignIn from './SignIn';
import SignOut from './SignOut';
import SignupWithEmail from './SignUpWithEmail';
import SignUpSelection from './SignUpSelect';
import UserDetails from './UserDetails';
import UserProfile from './UserProfile';
import routes from '../constants/routes';
import EmailComplete from './SignUp/EmailComplete';
import EmailVerification from './SignUp/EmailVerification';
import ConfirmEmailChange from './ChangeEmail/ConfirmEmailChange';
import ConfirmChangeEmail from './ChangeEmail/ConfirmChangeEmail';
import VerifyNewEmail from './ChangeEmail/VerifyNewEmail';
import RequestEmailChange from './ChangeEmail/RequestEmailChange';
import AuthorizeIdp from './AuthorizeIdp';

export const pages = [
    {
        component: Authorize,
        route: routes.AUTHORIZE,
    },
    {
        component: AuthorizeIdp,
        route: routes.AUTHORIZE_IDP,
    },
    {
        component: ChangeEmail,
        route: routes.CHANGE_EMAIL,
    },
    {
        component: UserDetails,
        route: routes.USER_DETAILS,
    },
    {
        component: ChangePassword,
        route: routes.CHANGE_PASSWORD,
    },
    {
        component: ConfirmForgotPassword,
        route: routes.CONFIRM_FORGOT_PASSWORD,
    },
    {
        component: ConfirmSignIn,
        route: routes.CONFIRM_SIGN_IN,
    },
    {
        component: ConfirmEmailChange,
        route: routes.CONFIRM_EMAIL_CHANGE,
    },
    {
        component: RequestEmailChange,
        route: routes.CONFIRM_REQUEST_EMAIL_CHANGE,
    },
    {
        component: ConfirmChangeEmail,
        route: routes.CONFIRM_EMAIL_CHANGE_V2,
    },
    {
        component: VerifyNewEmail,
        route: routes.VERIFY_EMAIL_CHANGE,
    },
    {
        component: Error,
        route: routes.ERROR,
    },
    {
        component: ForgotPassword,
        route: routes.FORGOT_PASSWORD,
    },
    {
        component: IdpToken,
        route: routes.IDP_TOKEN,
    },
    {
        component: ResetPassword,
        route: routes.RESET_PASSWORD,
    },
    {
        component: SetupMFA,
        route: routes.SETUP_MFA,
    },
    {
        component: SignIn,
        route: routes.SIGN_IN,
    },
    {
        component: SignOut,
        route: routes.SIGN_OUT,
    },
    {
        component: SignupWithEmail,
        route: routes.SIGN_UP_WITH_EMAIL,
    },
    {
        component: SignUpSelection,
        route: routes.SIGN_UP_SELECTION,
    },
    {
        component: EmailComplete,
        route: routes.SIGN_UP_COMPLETE_EMAIL,
    },
    {
        component: EmailVerification,
        route: routes.CONFIRM_SIGN_UP,
    },
    {
        component: SignUpSelection,
        route: routes.SIGN_UP,
    },
    {
        component: CompleteForgotPassword,
        route: routes.COMPLETE_FORGOT_PASSWORD,
    },
    {
        component: CompleteSetupMFA,
        route: routes.COMPLETE_MFA_SETUP,
    },
    {
        component: UserProfile,
        route: routes.PROFILE,
    },
];

export default pages;
